"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _themeProvider = require("@gravity/theme-provider");
var _templateObject;
/**
 * @typedef {Object} ThemedStyles
 * @property {import('styled-components').InterpolationValue[]} EQUILIBRIUM
 * @property {import('styled-components').InterpolationValue[]} [EVOLUTION]
 *
 * @typedef {Object} Options
 * @property {boolean} [useForwardRef] use when ref is passed as props
 * @property {string} [defaultTheme] use when ref is passed as props
 */
function cov_r2fcjnq56() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withThemedStyles.js";
  var hash = "4bfdc360129913aaed2627dc829c8d4bfe0b8aa2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withThemedStyles.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 30
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 36,
          column: 25
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "3": {
        start: {
          line: 41,
          column: 25
        },
        end: {
          line: 41,
          column: 46
        }
      },
      "4": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "5": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 95
        }
      },
      "6": {
        start: {
          line: 46,
          column: 26
        },
        end: {
          line: 49,
          column: 3
        }
      },
      "7": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 54
        }
      },
      "8": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 59
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 36,
            column: 25
          },
          end: {
            line: 36,
            column: 26
          }
        },
        loc: {
          start: {
            line: 40,
            column: 5
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 40
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        },
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 54
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 38,
            column: 17
          },
          end: {
            line: 38,
            column: 38
          }
        }],
        line: 38
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 81
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 39,
            column: 66
          },
          end: {
            line: 39,
            column: 81
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 19
          },
          end: {
            line: 39,
            column: 61
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 39,
            column: 34
          },
          end: {
            line: 39,
            column: 61
          }
        }],
        line: 39
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 42
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 47,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 47,
            column: 24
          },
          end: {
            line: 47,
            column: 45
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 48,
            column: 19
          },
          end: {
            line: 48,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 19
          },
          end: {
            line: 48,
            column: 37
          }
        }, {
          start: {
            line: 48,
            column: 41
          },
          end: {
            line: 48,
            column: 53
          }
        }],
        line: 48
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4bfdc360129913aaed2627dc829c8d4bfe0b8aa2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_r2fcjnq56 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_r2fcjnq56();
/**
 * @type {Options}
 */
var DEFAULT_OPTIONS = (cov_r2fcjnq56().s[0]++, {
  useForwardRef: false,
  defaultTheme: _themeProvider.TicketShopTheme.EQUILIBRIUM
});

/**
 * @type {ThemedStyles}
 */
var DEFAULT_THEMED_STYLES = (cov_r2fcjnq56().s[1]++, (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, null));

/**
 * Higher-order function to apply styles base on ticket shop theme to a styled component.
 *
 * @param {import('styled-components').StyledFunction<any>} styledFunction Styled function of styled-components
 * @param {ThemedStyles} [themedStyles] Styles by themes to applied to styled component
 * @param {Options} [options] Additional options to config styled component
 * @returns {React.ComponentType<any>}
 */
cov_r2fcjnq56().s[2]++;
var withThemedStyles = function withThemedStyles(styledFunction) {
  var themedStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_r2fcjnq56().b[0][0]++, DEFAULT_THEMED_STYLES);
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_r2fcjnq56().b[1][0]++, DEFAULT_OPTIONS),
    useForwardRef = _ref2.useForwardRef,
    _ref2$defaultTheme = _ref2.defaultTheme,
    defaultTheme = _ref2$defaultTheme === void 0 ? (cov_r2fcjnq56().b[2][0]++, _themeProvider.TicketShopTheme.EQUILIBRIUM) : _ref2$defaultTheme;
  cov_r2fcjnq56().f[0]++;
  var typeOfFunction = (cov_r2fcjnq56().s[3]++, (0, _typeof2.default)(styledFunction));
  cov_r2fcjnq56().s[4]++;
  if (typeOfFunction !== 'function') {
    cov_r2fcjnq56().b[3][0]++;
    cov_r2fcjnq56().s[5]++;
    throw new Error("TypeError: Expect first param type \"function\". Got \"".concat(typeOfFunction, "\"."));
  } else {
    cov_r2fcjnq56().b[3][1]++;
  }
  var StyledComponent = (cov_r2fcjnq56().s[6]++, styledFunction(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    ", ";\n  "])), function (_ref3) {
    var _ref3$themeContext = _ref3.themeContext,
      themeContext = _ref3$themeContext === void 0 ? (cov_r2fcjnq56().b[4][0]++, _themeProvider.DEFAULT_THEME_CONTEXT) : _ref3$themeContext;
    cov_r2fcjnq56().f[1]++;
    cov_r2fcjnq56().s[7]++;
    return themedStyles[(cov_r2fcjnq56().b[5][0]++, themeContext.theme) || (cov_r2fcjnq56().b[5][1]++, defaultTheme)];
  }));
  cov_r2fcjnq56().s[8]++;
  return (0, _themeProvider.withThemeConsumer)(StyledComponent, useForwardRef);
};
var _default = exports.default = withThemedStyles;